<template>
  <v-layout row justify-center>
    <v-dialog
      persistent
      v-model="show_modal"
      scrollable
      max-width="60%"
    >
      <div class="support_file_modal">
        <div class="support_file_modal__header" >
          <p class="support_file_modal__header--title">
            Soporte de pago del mes de {{spanishMonth(referenceDate)}}
          </p>
          <v-btn color="grey lighten-1" flat @click.native="closeModal()"><i class="material-icons">close</i></v-btn>
        </div>
        <div class="support_file_modal__body">
          <!-- <img :src="getImageServer() + image"> -->
          <v-expansion-panel focusable>
            <v-expansion-panel-content
              v-for="(support, i) in support_files" :key="i"              
            >
              <template v-slot:header>
                <div @click="selected_support_id = support.id">{{ spanishDate(support.created_at)}}</div>
              </template>
              <v-card>
                <v-card-text class="grey lighten-3">                  
                  <v-layout>
                    <v-flex xs5>
                      <v-img
                        :src="getImageServer() + support.file.url"
                        height="200px"
                        width="200px"
                        contain
                      ></v-img>
                    </v-flex>
                    <v-flex xs7>
                      <v-card-title primary-title>
                        <div>
                          <div class="headline">{{spanishMonth(support.created_at)}}</div>
                          <div><b>Comentarios: </b> {{support.comment !== null ? support.comment : 'Sin comentarios'}}</div>
                          <div>({{ new Date(support.created_at).getFullYear() }})</div>
                        </div>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <a :href="support.file.url" target="_blank"><v-btn class="v-btn theme--light info">Ver</v-btn></a>
                    <v-spacer></v-spacer>
                    <span>{{spanishState(support.state)}}</span>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
        <div class="support_file_modal__footer">          
          <v-btn class="v-btn theme--light error" :disabled="selected_support_id === null" @click="modifyState(false)">Rechazar</v-btn>
          <v-btn class="v-btn theme--light success" :disabled="selected_support_id === null" @click="modifyState(true)">Aceptar</v-btn>
        </div>
      </div>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props:{
    support_files: {
      type: Array
    },
    referenceDate: {
      type: String
    }
  },
  data(){
    return{
      show_modal: true,
      selected_support_id: null
    }
  },
  watch: {
    selected_support_id(){
      if(this.selected_support_id !== null){
        var support = this.support_files.find(item => item.id === this.selected_support_id)
        if(support.state === "PENDING"){
          this.selected_support_id = support.id
        }else{
          this.selected_support_id = null
        }
      }
    }
  },
  methods:{
    closeModal(){
      this.$emit('closeSupportModal', false)
    },
    modifyState(value){
      this.$emit('modifySupportState', { support_id: this.selected_support_id, value: value })
    },
    spanishDate(date){
      let arr= new Date(date).toLocaleDateString('en-US', { timeZone: "America/Bogota" })
      let myDate=new Date(arr);
      var myTime=myDate.getDay();
      var weekday=null
      if(!isNaN(myTime)){
          weekday=['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][myTime];
      }
      var month="Mes"
      if(!isNaN(myDate.getMonth())){
          month=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"][myDate.getMonth()]
      }
      return weekday + " " + myDate.getDate() + " de " + month
    },
    spanishMonth(date){
      let arr= new Date(date).toLocaleDateString('en-US', { timeZone: "America/Bogota" })
      let myDate=new Date(arr);
      var month="Mes"
      if(!isNaN(myDate.getMonth())){
        month=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"][myDate.getMonth()]
      }
      return month
    },
    spanishState(state){
      var spanish_state = ''
      if(state === 'PENDING'){
        spanish_state = 'Pendiente'
      }else if(state === 'REJECTED'){
        spanish_state = 'Rechazado'
      }else if (state === 'APPROVED'){
        spanish_state = 'Aprobado'
      }
      return spanish_state
    },
  },
  mounted(){
    this.selected_support_id = null
  }
}
</script>

<style scoped>
  #qrcode{
    display: flex !important;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/SupportFileModal.vue